import * as React from 'react';
import { cn } from '../../lib/utils';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'outline' | 'soft';
}

function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  const base =
    'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide';
  const variants = {
    default: 'bg-[hsl(var(--xircle-main))] text-white shadow-sm',
    outline: 'border border-slate-200 text-slate-600',
    soft: 'bg-slate-100 text-slate-700',
  };

  return <span className={cn(base, variants[variant], className)} {...props} />;
}

export { Badge };
